import { useBrandStore } from '@jotta/ui/useBrandTheme'
import { AppLayoutPortal } from '@jotta/ui/AppLayoutPortal'
import { Fab } from '@jotta/ui/Fab'
import { Onboarding } from '@jotta/ui/Onboarding'
import { t } from '@lingui/macro'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { FileContextMenu } from '../FileContextMenu/FileContextMenu'
import type { FolderStore } from './FolderStore'
const debug = Debug('jotta:files:FolderFab')

export interface FolderFabProps {
  store: FolderStore
}

export const FolderFab = observer<FolderFabProps>(function FolderFab({
  store,
}) {
  const actions = store.pathItem.fabMenuActions
  const disabled = !(actions && store.pathItem.canUpload)
  const branding = useBrandStore()

  return (
    <AppLayoutPortal slot="actionButton">
      <Onboarding asChild task="fab" align="top" onOpen={branding.closeDrawer}>
        <FileContextMenu
          context="FAB"
          actions={actions}
          disabled={disabled}
          onSelect={store.actions.onContextMenuSelect}
          path={store.apiPath}
          asChild
        >
          <Fab data-testid="FileFabButton" aria-label={t`Upload files`} />
        </FileContextMenu>
      </Onboarding>
    </AppLayoutPortal>
  )
})
